import React, { useContext } from "react";
import PropTypes from "prop-types";
import { InlineIcon } from "@iconify/react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { TranslationContext } from "../../../umbilical_tools";
import { useSuccessfulBooking } from "../../../hooks/booking";
import { brand } from "../../../context";
import { usePropertyLangTag } from "../../../hooks";
import styles from "./index.module.css";

const SuccessfulBooking = ({ product_type, page_session_id }) => {
  const { t } = useContext(TranslationContext);
  const history = useHistory();
  useSuccessfulBooking({ product_type, page_session_id });
  const langTag = usePropertyLangTag();
  const successMessage = useSelector((state) => {
    var msgKey = `booking_success_msg${langTag}`;
    var enMsgKey = "booking_success_msg";
    if (product_type === "flight")
      msgKey = `flight_booking_success_msg${langTag}`;

    var msg = state.WebsiteMetadata?.metadata?.[msgKey];
    if (!msg) msg = state.WebsiteMetadata?.metadata?.[enMsgKey];

    return msg;
  });

  return (
    <div className={styles.SuccessfulBooking}>
      <div className={styles.Card}>
        <InlineIcon icon="ep:success-filled" className={styles.successIcon} />
        <h4>{t("yourReservationHasBeenRegistered")}...</h4>
        <h5>{successMessage}</h5>
      </div>
      <button
        className="Button"
        data-brand={brand}
        onClick={() => history.push("/")}>
        Home
      </button>
    </div>
  );
};
SuccessfulBooking.propTypes = {
  product_type: PropTypes.string.isRequired,
  page_session_id: PropTypes.string.isRequired,
};
export default SuccessfulBooking;
